export const schoolInfo = {
  name: "The Indian Public School",
  shortName: "TIPS",
  location: "Bengaluru",
  tagline: "Fulfilling Dreams, One at a Time",
  phone: "7619305034",
  email: "infobengaluru@tipsmail.net",
  address: "# 78/4/1, Vidya Nidhi, Opposite Manyata Tech Park Gate-1, HBR Layout, Nagawara, Bengaluru – 560045",
  cbseAffiliationNumber: "830884",
  hours: "08:00 - 17:00, Monday to Saturday",
  whatsappNumber: "917619305034"
};

export const campuses = [
  {
    id: "main",
    code: "MAIN",
    name: "Main Campus",
    area: "Nagawara",
    address: "# 78/4/1, Vidya Nidhi, Opp. Manyata Tech Park Gate-1, HBR Layout, Nagawara, Bengaluru – 560045",
    phone: "7619305034",
    curricula: ["CBSE"],
    featured: true,
    grades: "Nursery to Grade XII",
    description: "Our flagship campus near Manyata Tech Park, offering world-class CBSE education in a state-of-the-art facility with modern labs and sports facilities.",
    mapLink: "https://maps.google.com/?q=TIPS+Bengaluru+Nagawara"
  },
  {
    id: "nikoo",
    code: "NIKOO",
    name: "Nikoo Homes Campus",
    area: "Thanisandra",
    address: "Nikoo Homes, Thanisandra Main Road, Bengaluru – 560077",
    phone: "7619305044",
    curricula: ["CBSE"],
    featured: false,
    grades: "Nursery to Grade X",
    description: "Conveniently located campus serving families in the Thanisandra and Nikoo Homes residential area of North Bangalore.",
    mapLink: "https://maps.google.com/?q=TIPS+Nikoo+Homes+Bengaluru"
  },
  {
    id: "banaswadi",
    code: "BWDI",
    name: "Banaswadi Campus",
    area: "Banaswadi",
    address: "Banaswadi Main Road, Banaswadi, Bengaluru – 560043",
    phone: "7619305045",
    curricula: ["CBSE"],
    featured: false,
    grades: "Nursery to Grade X",
    description: "A vibrant learning community in the heart of Banaswadi, with excellent connectivity to East Bangalore.",
    mapLink: "https://maps.google.com/?q=TIPS+Banaswadi+Bengaluru"
  },
  {
    id: "banashankari",
    code: "BSKI",
    name: "Banashankari Campus",
    area: "Banashankari",
    address: "Banashankari 3rd Stage, South Bangalore, Bengaluru – 560085",
    phone: "7619305046",
    curricula: ["CBSE"],
    featured: false,
    grades: "Nursery to Grade X",
    description: "Serving the educational needs of South Bangalore families with quality CBSE curriculum and dedicated faculty.",
    mapLink: "https://maps.google.com/?q=TIPS+Banashankari+Bengaluru"
  },
  {
    id: "sarjapur",
    code: "SRJP",
    name: "Sarjapur Campus",
    area: "Sarjapur Road",
    address: "Sarjapur Road, Bellandur, Bengaluru – 560035",
    phone: "7619305047",
    curricula: ["CBSE"],
    featured: false,
    grades: "Nursery to Grade X",
    description: "A growing campus at the IT corridor of Sarjapur Road, serving families in East and South-East Bangalore.",
    mapLink: "https://maps.google.com/?q=TIPS+Sarjapur+Bengaluru"
  },
  {
    id: "rtnagar",
    code: "RTN",
    name: "RT Nagar Campus",
    area: "RT Nagar",
    address: "RT Nagar Main Road, RT Nagar, Bengaluru – 560032",
    phone: "7619305048",
    curricula: ["CBSE"],
    featured: false,
    grades: "Nursery to Grade X",
    description: "Quality CBSE education close to home for families in North Bangalore's RT Nagar neighbourhood.",
    mapLink: "https://maps.google.com/?q=TIPS+RT+Nagar+Bengaluru"
  }
];

export const stats = [
  { id: 1, value: 20, suffix: "+", label: "Years of Excellence" },
  { id: 2, value: 6, suffix: "", label: "Campuses in Bengaluru" },
  { id: 3, value: 5000, suffix: "+", label: "Students Enrolled" },
  { id: 4, value: 100, suffix: "%", label: "CBSE Board Results" }
];

export const curricula = [
  {
    id: "cbse",
    badge: "CBSE",
    label: "Current Offering",
    labelColor: "emerald",
    title: "Central Board of Secondary Education",
    subtitle: "Nursery to Grade XII",
    description: "A strong academic framework rooted in national excellence. Known for conceptual clarity and emphasis on holistic development, CBSE equips students with intellectual and emotional intelligence for lifelong success.",
    features: ["Conceptual Clarity", "Holistic Development", "National Benchmarks", "Nursery to Grade XII"],
    borderColor: "border-orange-400",
    badgeBg: "bg-orange-50 text-orange-700 border-orange-200"
  },
  {
    id: "ib",
    badge: "IB PYP",
    label: "Upcoming",
    labelColor: "purple",
    title: "International Baccalaureate",
    subtitle: "Primary Years Programme",
    description: "Our upcoming IB PYP will foster young learners to think independently through inquiry-based, transdisciplinary approaches — building curious, confident, and compassionate global citizens.",
    features: ["Inquiry-Based Learning", "Transdisciplinary Framework", "Global Perspective", "Pre-KG to Grade V"],
    borderColor: "border-purple-400",
    badgeBg: "bg-purple-50 text-purple-700 border-purple-200"
  },
  {
    id: "cambridge",
    badge: "Cambridge",
    label: "Upcoming",
    labelColor: "blue",
    title: "Cambridge International",
    subtitle: "Primary · IGCSE · AS & A Levels",
    description: "Cambridge Primary through IGCSE to AS/A Levels — one of the world's most respected curricula, preparing students for top universities worldwide with decades of educational research.",
    features: ["Cambridge Primary", "IGCSE Programme", "AS & A Levels", "Grades I to XII"],
    borderColor: "border-blue-400",
    badgeBg: "bg-blue-50 text-blue-700 border-blue-200"
  }
];

export const tipsEdgeFeatures = [
  { id: 1, icon: "BookOpen", title: "CBSE Excellence", description: "National curriculum delivering holistic development and conceptual clarity from Nursery to Grade XII." },
  { id: 2, icon: "Target", title: "Career Counselling", description: "Dedicated university guidance and career advisory from Grade 9 through Grade 12 with top Indian & global institutes." },
  { id: 3, icon: "Microscope", title: "STEAM Labs", description: "Science, Technology, Engineering, Arts & Maths labs fully equipped across all 6 campuses." },
  { id: 4, icon: "Trophy", title: "Sports & Athletics", description: "Structured curriculum-integrated sports — cricket, football, athletics, swimming, and more." },
  { id: 5, icon: "MapPin", title: "6 Campuses", description: "All within Bengaluru — world-class CBSE education accessible across the city." },
  { id: 6, icon: "Bus", title: "Safe Transport", description: "Dedicated school buses covering all major residential routes across Bengaluru." },
  { id: 7, icon: "Globe", title: "Global Exposure", description: "Student Exchange Programmes across International Campuses and Global MUN opportunities." },
  { id: 8, icon: "GraduationCap", title: "Expert Educators", description: "Qualified educators who give personalized attention with innovative teaching methods." }
];

export const events = [
  { id: 1, category: "ACADEMIC", campus: "All Campuses", date: "Aug 10, 2025", title: "Annual Science & Innovation Fair", description: "250+ student projects across Physics, Chemistry, Biology, Robotics and AI. Open to parents.", color: "blue" },
  { id: 2, category: "SPORTS", campus: "All Campuses", date: "Aug 23, 2025", title: "Annual Sports Day", description: "Track & field events, team sports, and athletics competitions across all grade levels.", color: "green" },
  { id: 3, category: "CULTURAL", campus: "Main Campus", date: "Sep 5–6, 2025", title: "Annual Day 2025", description: "An evening of theatre, dance, and music showcasing the best of TIPS student talent.", color: "purple" },
  { id: 4, category: "ACADEMIC", campus: "All Campuses", date: "Sep 18, 2025", title: "PTM — Term 1 Results", description: "Term 1 Parent-Teacher Meeting for Grades I–XII. Please carry your ward's report card.", color: "orange" },
  { id: 5, category: "ADMISSIONS", campus: "All Campuses", date: "Oct 1, 2025", title: "Open Day 2025", description: "Visit our campuses, meet our educators, and learn about our academic programmes.", color: "teal" },
  { id: 6, category: "EVENT", campus: "All Campuses", date: "Oct 2, 2025", title: "Gandhi Jayanti — Eco Drive", description: "Cleanliness drive and plantation activity in the spirit of Swachh Bharat.", color: "green" },
  { id: 7, category: "CELEBRATION", campus: "All Campuses", date: "Nov 14, 2025", title: "Children's Day Celebrations", description: "Special programmes and activities celebrating the joy of childhood and learning.", color: "pink" },
  { id: 8, category: "ADMISSIONS", campus: "All Campuses", date: "Nov 28, 2025", title: "Grade 11 Admission Open Day", description: "Career fairs, counselling sessions, and information sessions for Grade 11 aspirants.", color: "blue" }
];

export const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Channa",
    role: "Parent of Anant Channa",
    grade: "Grade 2",
    campus: "Main Campus",
    initial: "A",
    text: "We wish the entire team all the very best. I am so pleased and happy with how my child has progressed. My child always talks about school and the work he is doing, he is getting on really well. Very good teachers and really helpful — my son has learnt a lot of things. I am very happy with school, teachers and staff."
  },
  {
    id: 2,
    name: "Mr. Lenin Joseph",
    role: "Parent of Karen Adriya",
    grade: "Nursery",
    campus: "Main Campus",
    initial: "L",
    text: "My daughter is always happy to attend classes with full of smiles. I attribute this to the exemplary teaching and community feel of the school. Really impressed with the learning and development provided by the school."
  },
  {
    id: 3,
    name: "Ms. Shruti K.",
    role: "Parent of Disha Rao",
    grade: "UKG-B",
    campus: "Main Campus",
    initial: "S",
    text: "We are extremely happy about our daughter studying at the school. The teachers are very friendly, put in immense efforts very creatively to teach the foundation courses for kindergarten, at the same time, make sure the classes are fun and engaging for the little ones."
  },
  {
    id: 4,
    name: "Mrs. Priya Jaichandran",
    role: "Parent of Niveda",
    grade: "Grade 6",
    campus: "Main Campus",
    initial: "P",
    text: "I am totally happy and satisfied with the functioning of the school and management. I congratulate the entire team of the school. Each and every person has been a building block for this success."
  }
];

export const galleryImages = [
  { id: 1, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600138255-5-ecs-420x315.jpg", alt: "School Activities", category: "Events" },
  { id: 2, src: "https://tips-bengaluru.org/wp-content/uploads/2020/08/6-420x315.jpg", alt: "Campus Life", category: "Campus" },
  { id: 3, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600142823-1-ecs-420x315.jpg", alt: "Student Activities", category: "Academics" },
  { id: 4, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600142823-4-ecs-420x315.jpg", alt: "Classroom Learning", category: "Academics" },
  { id: 5, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600134781-6-ecs-420x315.jpg", alt: "School Events", category: "Events" },
  { id: 6, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600137937-3-ecs-420x315.jpg", alt: "Student Projects", category: "Academics" },
  { id: 7, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/arts-420x315.jpg", alt: "Arts & Culture", category: "Arts" },
  { id: 8, src: "https://tips-bengaluru.org/wp-content/uploads/2021/01/gallery-1600142113-1-ecs-420x280.jpg", alt: "School Programs", category: "Events" },
  { id: 9, src: "https://images.pexels.com/photos/9159042/pexels-photo-9159042.jpeg?auto=compress&cs=tinysrgb&w=420&h=315&fit=crop", alt: "Modern Learning", category: "Academics" },
  { id: 10, src: "https://images.unsplash.com/photo-1577896851231-70ef18881754?w=420&h=315&fit=crop", alt: "Teacher with Students", category: "Campus" },
  { id: 11, src: "https://images.pexels.com/photos/8926848/pexels-photo-8926848.jpeg?auto=compress&cs=tinysrgb&w=420&h=315&fit=crop", alt: "School Campus", category: "Campus" },
  { id: 12, src: "https://images.pexels.com/photos/3769714/pexels-photo-3769714.jpeg?auto=compress&cs=tinysrgb&w=420&h=315&fit=crop", alt: "Students Learning", category: "Academics" }
];

export const phoneNumbers = [
  { label: "Main Campus Admissions", number: "7619305034" },
  { label: "HR Manager", number: "7619305035" },
  { label: "Transportation", number: "7619305036" },
  { label: "Front Desk", number: "7619305038" }
];

export const enquiryFormCampuses = [
  "Main Campus (Nagawara)",
  "Nikoo Homes Campus",
  "Banaswadi Campus",
  "Banashankari Campus",
  "Sarjapur Campus",
  "RT Nagar Campus"
];

export const faqData = [
  {
    id: 1,
    question: "Which curriculum does TIPS Bengaluru currently offer?",
    answer: "We currently offer the CBSE curriculum from Early Years (Nursery) onwards through Grade XII. The school plans to offer IB from Pre-KG to Grade 5 and Cambridge curriculum from Grade 6 onwards in the near future."
  },
  {
    id: 2,
    question: "What safety measures are in place for children?",
    answer: "Safety is top priority. Protocols are in place for Medical Safety, Fire Safety, Electrical Safety and Internet Safety. Students are supervised in every sphere with surveillance inside classes and corridors."
  },
  {
    id: 3,
    question: "What grades does TIPS Bengaluru cater to?",
    answer: "TIPS Bengaluru caters from Early Years (Nursery, LKG, UKG) through Primary (Grade I–V), Lower Secondary (Grade 6–8), Secondary (Grade 9–10) and Senior Secondary (Grade 11–12)."
  },
  {
    id: 4,
    question: "Does the school have transport facilities?",
    answer: "Yes, dedicated school buses cover all major residential routes across Bengaluru. Contact our transportation department at 7619305036 for route information."
  },
  {
    id: 5,
    question: "How do I apply for admissions?",
    answer: "Apply online through our admissions form, visit our campus in person, or call our admissions team at 7619305034. Our team will assist you with all details."
  }
];

export const academicsData = [
  {
    id: "early-years",
    title: "Early Years",
    grades: "Nursery, LKG & UKG",
    description: "The Early Years programme lays a strong foundation through play-based learning, creativity, and social development in a nurturing environment.",
    features: ["Play-Based Learning", "Social Development", "Language Skills", "Creative Arts"]
  },
  {
    id: "primary",
    title: "Primary",
    grades: "Grade I to Grade V",
    description: "Building core academic skills with a focus on critical thinking, creativity, and character development through the CBSE framework.",
    features: ["Core Academics", "Critical Thinking", "STEAM Activities", "Value Education"]
  },
  {
    id: "lower-secondary",
    title: "Lower Secondary",
    grades: "Grade 6 to Grade 8",
    description: "Deepening academic knowledge while encouraging independent thinking, collaborative projects, and exploration of interests.",
    features: ["Subject Specialisation", "Project-Based Learning", "Sports Integration", "Leadership Skills"]
  },
  {
    id: "secondary",
    title: "Secondary",
    grades: "Grade 9 & Grade 10",
    description: "Preparing students for CBSE Board examinations with rigorous academics, internal assessments, and career awareness.",
    features: ["Board Exam Preparation", "Career Awareness", "Internal Assessments", "Skill Development"]
  },
  {
    id: "senior-secondary",
    title: "Senior Secondary",
    grades: "Grade 11 & Grade 12",
    description: "Career-focused academics with Science, Commerce, and Humanities streams, university counselling, and top board scores every year.",
    features: ["Science / Commerce / Humanities", "University Counselling", "Career Fairs", "Global MUNs"]
  }
];
